import React from 'react';
import { useLocation, useSearchParams, matchPath } from 'react-router-dom';
import styles from './onboarding-step-indicator.module.scss';

const STEP_MAP: { pattern: string; step: number; label: string }[] = [
  {
    pattern: '/user/business/registration',
    step: 1,
    label: 'Регистрация бизнеса',
  },
  {
    pattern: '/user/business/:id/create-point',
    step: 2,
    label: 'Регистрация точки',
  },
  {
    pattern: '/user/point/:id/create-employee',
    step: 3,
    label: 'Регистрация сотрудника',
  },
];

export const OnboardingStepIndicator: React.FC = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  if (searchParams.get('onboarding') !== 'true') return null;

  const match = STEP_MAP.find((entry) =>
    matchPath(entry.pattern, location.pathname)
  );

  if (!match) return null;

  return (
    <div className={styles.indicator}>
      <span className={styles.indicator__text}>
        Шаг {match.step}/3: {match.label}
      </span>
    </div>
  );
};
